module.exports = __webpack_public_path__ + "img/xmasParty9.702faa87.jpg";